// eslint-disable-next-line import/prefer-default-export
export function isPrint() {
  if (typeof window === 'undefined') return false
  return window.location?.hash === '#print'
}
